import axiosInstance from "../../routes/axiosConfig";

export async function criarOrdemServico(dados, pdfFile = null) {
  try {
    if (pdfFile) {
      const formData = new FormData();
      formData.append("pdf", pdfFile);
      formData.append("dados", JSON.stringify(dados));

      const response = await axiosInstance.post("/serviceOrder", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    }

    const response = await axiosInstance.post("/serviceOrder", dados);
    return response.data;
  } catch (error) {
    console.error("Erro na função criarOrdemServico:", error);
    throw error;
  }
}

export async function buscarTodasUnidadesDisponiveis() {
  try {
    const response = await axiosInstance.get("/companyAddress/all");
    return response.data;
  } catch (error) {
    console.error("Erro na função buscarTodasUnidadesDisponiveis:", error);
    throw error;
  }
}

export async function buscarOrdemServicoPorId(serviceOrderid) {
  try {
    const response = await axiosInstance.get("/serviceOrder", {
      params: {
        serviceOrderid: serviceOrderid,
        page: 0,
        size: 1,
        sort: "string",
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      `Erro na função buscarOrdemServicoPorId ${serviceOrderid}:`,
      error
    );
    throw error;
  }
}

export async function atualizarOrdemServico(serviceOrderid, dados) {
  try {
    const payload = {
      ...dados,
      serviceOrderid: serviceOrderid,
    };

    const response = await axiosInstance.put("/serviceOrder", payload);
    return response.data;
  } catch (error) {
    console.error(
      `Erro na função atualizarOrdemServico ${serviceOrderid}:`,
      error
    );
    throw error;
  }
}
